'use strict';

var getKeysWithObjectCoercion = require('./getKeysWithObjectCoercion');

function objectSize(obj) {
  return getKeysWithObjectCoercion(obj).length;
}

module.exports = objectSize;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/internal/objectSize.js
// module id = 307
// module chunks = 0